import { SignOutByServerAnalyticsEvent } from '$logic/auth/types'
import { LocalFind, LocalInsert, LocalRemove } from '@weblite/persist'
import { dateWithOffset } from '$logic/client-device/time-offset.service'
import * as R from 'ramda'
import { authStorage } from '$logic/auth/storage'

let signOutByServerAnalyticsEvent: SignOutByServerAnalyticsEvent | undefined =
  undefined

const SIGN_OUT_BY_SERVER_LOCAL_KEY = 'signOutByServerEvent'

export function saveSignOutByServerAnalyticsEventToRam(userId?: string) {
  signOutByServerAnalyticsEvent = {
    date: dateWithOffset(),
    signedOutUserId: userId,
  }
}

export function saveSignOutByServerAnalyticsEventToLocal() {
  if (signOutByServerAnalyticsEvent)
    LocalInsert(SIGN_OUT_BY_SERVER_LOCAL_KEY, signOutByServerAnalyticsEvent)
}

export function sendSignOutByServerAnalyticsEvent() {
  const event = LocalFind(SIGN_OUT_BY_SERVER_LOCAL_KEY) as
    | SignOutByServerAnalyticsEvent
    | undefined

  if (event) {
    analite('SIGN_OUT_BY_SERVER', R.dissoc('date', event), true, event.date)
    removeSignOutByServerAnalyticsEvent()
  } else {
    if (navigator.storage?.estimate)
      navigator.storage
        .estimate()
        .then(({ quota, usage }) => {
          analite('OPEN_LOGIN_PAGE', {
            authStorage: { ...authStorage.get() },
            quotaEstimation: {
              quota: quota
                ? (quota / 1024 / 1024).toFixed(2) + 'MB'
                : undefined,
              usage: usage
                ? (usage / 1024 / 1024).toFixed(2) + 'MB'
                : undefined,
            },
          })
        })
        .catch(() => {
          analite('OPEN_LOGIN_PAGE', {
            authStorage: { ...authStorage.get() },
          })
        })
    else
      analite('OPEN_LOGIN_PAGE', {
        authStorage: { ...authStorage.get() },
      })
  }
}

export function removeSignOutByServerAnalyticsEvent() {
  LocalRemove(SIGN_OUT_BY_SERVER_LOCAL_KEY)
  signOutByServerAnalyticsEvent = undefined
}
